import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row mb-3" }
const _hoisted_2 = { class: "col-6" }
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = { class: "row mb-3" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "form-label" }
const _hoisted_7 = { class: "form-text" }
const _hoisted_8 = { class: "row mb-3" }
const _hoisted_9 = { class: "col-6" }
const _hoisted_10 = { class: "form-label" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_12 = { class: "row mb-3" }
const _hoisted_13 = { class: "col-4" }
const _hoisted_14 = { class: "col-8" }
const _hoisted_15 = { class: "row mb-3" }
const _hoisted_16 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseOffcanvasButtonClose = _resolveComponent("BaseOffcanvasButtonClose")!
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_input_text = _resolveComponent("input-text")!
  const _component_input_select = _resolveComponent("input-select")!
  const _component_LabelsInput = _resolveComponent("LabelsInput")!
  const _component_InputTextEditor = _resolveComponent("InputTextEditor")!
  const _component_base_offcanvas_button_close = _resolveComponent("base-offcanvas-button-close")!
  const _component_GenericFormWrapper = _resolveComponent("GenericFormWrapper")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_BaseTitle, {
      title: _ctx.$t('mailingTemplate'),
      mode: _ctx.mode
    }, {
      buttons: _withCtx(() => [
        _createVNode(_component_BaseOffcanvasButtonClose)
      ]),
      _: 1
    }, 8, ["title", "mode"]),
    _createVNode(_component_GenericFormWrapper, {
      submitData: _ctx.submitData,
      pageUI: _ctx.pageUI
    }, {
      content: _withCtx(({errors}) => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_input_text, {
              modelValue: _ctx.template.name,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.template.name) = $event)),
                _ctx.onFormDataChanged
              ],
              label: _ctx.$t('name'),
              name: _ctx.$t('name'),
              rules: "required|max:255",
              errors: errors
            }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "name", "errors"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_input_select, {
              modelValue: _ctx.template.season_code,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((_ctx.template.season_code) = $event)),
                _ctx.onFormDataChanged
              ],
              label: _ctx.$t('season'),
              name: _ctx.$t('season'),
              options: _ctx.seasonOptions,
              errors: errors
            }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "name", "options", "errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('description')), 1),
            _withDirectives(_createElementVNode("textarea", {
              class: "form-control",
              rows: "4",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.template.description) = $event)),
              onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onFormDataChanged && _ctx.onFormDataChanged(...args)))
            }, null, 544), [
              [_vModelText, _ctx.template.description]
            ]),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('optional')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('labels')), 1),
            _createVNode(_component_LabelsInput, {
              modelValue: _ctx.template.labels,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.template.labels) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_input_select, {
              modelValue: _ctx.template.notification_template.language_code,
              "onUpdate:modelValue": [
                _cache[5] || (_cache[5] = ($event: any) => ((_ctx.template.notification_template.language_code) = $event)),
                _ctx.onFormDataChanged
              ],
              label: _ctx.$t('language'),
              name: _ctx.$t('language'),
              options: _ctx.languageOptions,
              rules: "required",
              errors: errors
            }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "name", "options", "errors"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_input_text, {
              modelValue: _ctx.template.notification_template.subject,
              "onUpdate:modelValue": [
                _cache[6] || (_cache[6] = ($event: any) => ((_ctx.template.notification_template.subject) = $event)),
                _ctx.onFormDataChanged
              ],
              label: _ctx.$t('subject'),
              name: _ctx.$t('subject'),
              errors: errors
            }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "name", "errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_InputTextEditor, {
              modelValue: _ctx.template.notification_template.content,
              "onUpdate:modelValue": [
                _cache[7] || (_cache[7] = ($event: any) => ((_ctx.template.notification_template.content) = $event)),
                _ctx.onFormDataChanged
              ],
              label: _ctx.$t('content'),
              name: _ctx.$t('content'),
              rules: "required",
              errors: errors
            }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "name", "errors"])
          ])
        ])
      ]),
      buttons: _withCtx(() => [
        _createVNode(_component_base_offcanvas_button_close, {
          ref: "closeButton",
          class: "btn btn-light",
          disabled: _ctx.pageUI.isSubmitting()
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('close')), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }, 8, ["submitData", "pageUI"])
  ]))
}